import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default Vue.extend({
  components: {
        Confirm,
    },
    data () {
      return {
        Jobs: [],
       
      }
    },

    created(){
     this.jobList();
    },

    methods : {
      async jobList(){
        try{
          console.log("entry");
          this.Jobs = [];
          let token =  localStorage.getItem("jwt");
          let userId =  localStorage.getItem("userId");
          console.log("entry1");
          if (token) { 
            const auth = {
              headers: {authorization: token} 
            }   
            console.log("entry2");
            let resp1 = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
            
            console.log("respJ",resp1);
            console.log("entry3");
            if (resp1.status === 200 && resp1.data.message){
              if (resp1.data.jobs.length>2) {
                for (let i = 0; i < 2; i++) {
                  this.Jobs.push(resp1.data.jobs[i]);
                }
              } else {
                for (let i = 0; i < resp1.data.jobs.length; i++) {
                  this.Jobs.push(resp1.data.jobs[i]);
                }
              }
              for (let i = 0; i < this.Jobs.length; i++) {
                for (let j = 0; j < this.Jobs[i].exam_dates.length; j++) {
                  var day = moment.unix(this.Jobs[i].exam_dates[j]);
                  this.Jobs[i].exam_dates[j] = day.format('MMMM Do YYYY, h:mm a')
                }
              }
            }
          }
        }catch(error){
          
          console.log('*** error.response ***',error.response.status);
          console.log('*** error.response ***',error.response.data.message);
          console.log('*** jwt ***',);
          if (error.response.status == 404 && error.response.data.message=='The token is not valid') {
            console.log('*** jwt ***',);
            const jwt = localStorage.getItem("jwt");
            const is_admin = localStorage.getItem("is_admin");
            const admin_name = localStorage.getItem("admin_name");
            
            const user_id = localStorage.getItem("user_id");
            // //@ts-ignore
            // let resp = await this.$http.post('/logout',{'user_id': user_id});
            if (jwt) {
              localStorage.removeItem("jwt");
            }
            if (is_admin) {
              localStorage.removeItem("is_admin");
            }
            if (admin_name) {
              localStorage.removeItem("admin_name");
            }
            if (user_id) {
              localStorage.removeItem("user_id");
            }
            window.location.href ='https://crackingitjobs.com/#/';
          }
        }
      },
        // if (token) { 
        //   Axios.post('https://yqroi4mbbd.execute-api.us-east-1.amazonaws.com/prod/admin-job-listing',{
        //     token
        //   }).then(resp1onse => {
        //     console.log(resp1onse);
        //     if (!resp1onse.data.error){
        //       if (resp1onse.data.data.length>2) {
        //         for (let i = 0; i < 2; i++) {
        //           this.Jobs.push(resp1onse.data.data[i]);
        //         }
        //       } else {
        //         for (let i = 0; i < resp1onse.data.data.length; i++) {
        //           this.Jobs.push(resp1onse.data.data[i]);
        //         }
        //       }
        //       console.log("jbs",this.Jobs);
        //     }
            // else if (resp1onse.data.error == true && resp1onse.data.errorCode === -100) {
            //   this.snackbar = true;
            //   this.showMessage = 'Session Expired. Please login.'
            //   localStorage.removeItem("is_admin");
            //   localStorage.removeItem("jwt");
            //   if (localStorage.getItem("admin_name")) {
            //       localStorage.removeItem("admin_name");
            //   }
            //   this.$router.push('/login').catch(()=>{});
            // }
      //     })
      //   }
      // },

      goto_details(id){
        console.log("item",id);
        localStorage.setItem("JobId",id);
       // this.$router.push("/job-application/"+id);
        this.$router.push({ name: 'job-application-details', params: { id: id } })
      },
      edit(jid){
        // this.$router.push("/update-job-application/"+jid);
        this.$router.push({ name: 'update_job-application', params: { id: jid } })
      },
      all_job_view(){
        this.$router.push({ name: 'all job'})
      },
      all_draft_job_view(){
        this.$router.push({ name: 'draft_job'})
      },

      invite_job(id){
        // this.$router.push("/recomended_talent/"+id);
        this.$router.push({ name: 'recomended_talent', params: { id: id } })
      },
      async job_delete(id){
        // try {
        //   if (await this.alertMsg('Remove Job','info','Are you sure?')) {

        //     let token = localStorage.getItem("jwt");
        //     let userId = localStorage.getItem("userId");

        //     console.log(token);
        //     console.log(userId);

        //     if (token && userId) { 
        //       const auth = {
        //         headers: {authorization: token} 
        //       }   
        //       let res = await this.$http.post('/job/removeJob',{
        //           job_id: id,
        //           user_id: userId
        //       },auth);

        //         console.log(res);
        //         console.log(res.data);

        //       if (res.status === 200 && res.data.message === "Job removed successfully") {
        //           console.log("jhjhggyugyggygy");
        //           this.snackbar = true;
        //           this.showMessage = 'Removed Successfully.'
        //           this.jobList();
        //       } else {
        //           this.snackbar = true;
        //           this.showMessage = 'Something wrong! Please try again.'
        //       }
        //     }
        //   }
        // }catch(error){}

        try {
          console.log('del',id)
           this.$swal({
            title: 'Remove Job',
            text: 'Are you sure?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText:'Cancel',
            customClass: 'swal-title-jobapplication'
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_job(id);
          }
         
        })
  
        }catch(error){}
      },

    //   alertMsg(message,type,title) {
    //     this.$swal({
    //         title: title,
    //         text: message,
    //         icon: type,
    //         showCancelButton: true,
    //         confirmButtonText: 'Confirm',
    //         cancelButtonText:'Cancel',
    //         customClass: 'swal-title'
    //     })
    // }

    async delete_job(id){
    
      let token = localStorage.getItem("jwt");
          let userId = localStorage.getItem("userId");

          console.log(token);
          console.log(userId);

          if (token && userId) { 
            const auth = {
              headers: {authorization: token} 
            }   
            let res = await this.$http.post('/job/removeJob',{
                job_id: id,
                user_id: userId
            },auth);

              console.log(res);
              console.log(res.data);

            if (res.status === 200 && res.data.message === "Job removed successfully") {
                console.log("jhjhggyugyggygy");
                this.snackbar = true;
                this.showMessage = 'Removed Successfully.'
                this.jobList();
            } else {
                this.snackbar = true;
                this.showMessage = 'Something wrong! Please try again.'
            }
          }

    }

    }
  });
